import apiClient from "./config";
import { SEARCH_ENDPOINTS } from "./endpoints";

const searchService = {
  // Get Search Results
  filterCity: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.FILTER_CITY, data);
  },
  getCityDetails: (data) => {
    return apiClient.get(SEARCH_ENDPOINTS.GET_CITY_DETAILS, { params: data });
  },
  getSchoolData: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.GET_SCHOOL_DETAILS, data);
  },
  getPublicSchoolData: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.PUBLIC_GET_SCHOOL_DETAILS, data);
  },
  checkFilterCity: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.CHECK_FILTER_CITY, data);
  },
  checkCitySearch: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.CHECK_CITY_SEARCH, data);
  },
  searchSessionId: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.SEARCH_SESSION_ID, data);
  },
  searchAnalytics: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.SEARCH_ANALYTICS, data);
  },
  trackSearchCityClick: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.TRACK_SEARCH_CITY_CLICK, data);
  },
  searchSessionEnd: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.SEARCH_SESSION_END, data);
  },
  searchBookmark: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.SEARCH_BOOKMARK, data);
  },
  checkMultipleBookmarks: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.CHECK_MULTIPLE_BOOKMARKS, data);
  },
  getBookmarks: (params) => {
    return apiClient.get(SEARCH_ENDPOINTS.GET_BOOKMARKS, { params });
  },
  cityAutocomplete: (params) => {
    return apiClient.get(SEARCH_ENDPOINTS.CITY_AUTOCOMPLETE, { params });
  },
  getMortgageCityData: (data) => {
    return apiClient.post(SEARCH_ENDPOINTS.MORTGAGE_CITY_DATA, data);
  },
  getCitySpotlight: () => {
    return apiClient.get(SEARCH_ENDPOINTS.CITY_SPOTLIGHT);
  },
};

export default searchService;
